<template lang="pug">
.container.grid-lg.py-2
  filter-component(
    @submit='onFilter',
    :auto-filter='autoFilter',
    :default-query='q',
    filter-key='docs-enabled-filters'
  )
    div(slot='additionalButtons')
      doc-tipos-dropdown(@selected='onDocTipoSelected')
        .btn.btn-action.s-circle.btn-sm
          i.icon.icon-plus
  load-manager(:status='status')
    list-manager(:status='status', :count='list.length')
      .card.mb-2(v-for='doc in list')
        .card-header
          .columns
            .column.col-auto
              .card-title.h6 {{ doc.numero }}/{{ doc.ano }}
            .column
              .card-subtitle.text-gray.text-small {{ doc.modelo.descricao }}
        .card-body
          .columns
            .column.col-2.col-md-4.col-sm-12.mb-2
              .item-col
                .abbr {{ 'doc.cadastro' | tModel }}
                  span(v-if='doc.cadastro') {{ doc.cadastro | enums('cadastro.tipo') }}
                .small
                  span(v-if='doc.cadastro') {{ doc.cadastro.numero }}
                  span(v-else) -
            item-col.col-2.col-md-4.col-sm-12.mb-2(
              label='doc.situacao',
              :value='doc.situacao.descricao'
            )
            item-col.col-2.col-md-4.col-sm-12.mb-2(
              label='doc.valor_total',
              :value='doc.valor_total | currency("R$ ")'
            )
            item-col.col-2.col-md-4.col-sm-12.mb-2(
              label='doc.existe_senha_web',
              :value='doc.existe_senha_web ? "Sim" : "Não"'
            )
            item-col.col-2.col-md-4.col-sm-12.mb-2(
              label='doc.reincidente',
              :value='doc.reincidente'
            )
            item-col.col-2.col-md-4.col-sm-12.mb-2(
              label='doc.comentario_situacao',
              :value='doc.comentario_situacao ? doc.comentario_situacao.descricao : ""'
            )
          .columns.mt-2
            item-col.mb-2(
              label='doc.fiscal',
              :value='doc.fiscal ? doc.fiscal.nome : "-"'
            )
        .card-footer
          .columns
            .column
              abbr.tooltip(:data-tooltip='"doc.created_at" | tModel') {{ doc.created_at | date }}
            .column.col-auto
              router-link.btn.btn-link.tooltip.tooltip-left(
                :data-tooltip='"views.buttons.show.label" | translate',
                :to='{ name: "fiscalizacao.docs.show", params: { id: doc.id } }'
              )
                btn-content(name='show')
      .my-2.text-right(v-if='pages > 1')
        btn-paginate(
          :page='page',
          :pages='pages',
          :count='count',
          @go-page='goPage',
          @prev-page='prevPage',
          @next-page='nextPage'
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FilterComponent from "./components/Filter"

export default {
  vuex: {
    "fiscalizacao/docs": vuexDefaultMapping,
  },

  components: { FilterComponent },

  data() {
    return { q: { id_order_by: "desc" } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.setQuery({ ...q })
      this.setPage(1)
      this.fetchList()
    },
    onDocTipoSelected(docTipo) {
      this.$router.push({
        name: "fiscalizacao.docs.create.modelo",
        params: { docTipo },
      })
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
